<template>
  <div>
    <v-tour :callbacks="callbacks" name="AssetsWithDataTour" :steps="steps"></v-tour>
  </div>
</template>
<script>
export default {
  name: 'my-tour',
  data () {
    return {
      callbacks: {
        onSkip: () => {
          console.log('skipping')
          this.$emit('stopShowingThisTour')
        },
        onFinish: () => {
          console.log('finished')
          this.$emit('stopShowingThisTour')
        },
      },
      steps: [
        {
          target: '#chart_list',  // We're using document.querySelector() under the hood
          header: {
            title: 'Chart list',
          },
          content: `
            You will spend a lot of time in charts, avoiding the need to stare at spreadsheets
            like with other tools. The default chart, Basic Site Structure, is useful for
            most sites (those that logically organize by URL "folders"). Some of the charts
            in the pulldown require data that you won't have at the outset.
          `,
          params: {
            placement: 'right' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#table_toggles',  // We're using document.querySelector() under the hood
          header: {
            title: 'Table view',
          },
          content: `
            Although in general you interact with charts, you can also see a table view of
            the content. Note that by default Chimera will only show unclassified content
            (content that you haven't decided upon yet) and will show in random order (so
            you see a better sample of the content, rather than just showing what happened
            to be the import order). The columns in the table are tied to the the fields shown
            in the chart.
          `,
          params: {
            placement: 'top-start' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#primary-chart',  // We're using document.querySelector() under the hood
          header: {
            title: 'The chart is interactive',
          },
          content: `
            You can click in the bars in the chart to see samples of the underlying data.
          `,
          params: {
            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#import',  // We're using document.querySelector() under the hood
          header: {
            title: 'Importing data',
          },
          content: `
            Content Chimera does not tie you to a particular set of fields about your data.
            You can also merge data from other sources (via CSVs) or scrape data out of pages.
            Unless you have archived a site, you can import more data into it.
          `,
          params: {
            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#rules_global_nav',  // We're using document.querySelector() under the hood
          header: {
            title: 'Use rules to decide about content',
          },
          content: `
            Content Chimera facilitates making decisions about content. Instead of trying
            to review each piece of content individually, you can define rules. The rules
            page has the complete list of all your defined rules, but the easiest way to
            create rules is by clicking in the chart below and then clicking "Create rule".
          `,
          params: {
            placement: 'bottom' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
      ]
    }
  },
  mounted: function () {
    this.$tours['AssetsWithDataTour'].start()
  }
}
</script>